import { render, staticRenderFns } from "./B-4-1__CSRPage_ProjectFilter.vue?vue&type=template&id=56a1a6ae&"
import script from "./B-4-1__CSRPage_ProjectFilter.vue?vue&type=script&lang=js&"
export * from "./B-4-1__CSRPage_ProjectFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports